import 'css-chunksrc/client/pages/taskPage/styles.scss';export default {
  "task": "_task_56btq_1",
  "taskLoading": "_taskLoading_56btq_9",
  "loader": "_loader_56btq_15",
  "loaderMain": "_loaderMain_56btq_29",
  "main": "_main_56btq_36",
  "content": "_content_56btq_43",
  "secondaryCriteria": "_secondaryCriteria_56btq_49",
  "label": "_label_56btq_54",
  "row": "_row_56btq_60",
  "configurationIconBox": "_configurationIconBox_56btq_71",
  "configurationIcon": "_configurationIcon_56btq_71",
  "scrollWrapper": "_scrollWrapper_56btq_89",
  "timeline": "_timeline_56btq_98",
  "timestamp": "_timestamp_56btq_105",
  "comments": "_comments_56btq_116",
  "header": "_header_56btq_124",
  "contentHeader": "_contentHeader_56btq_137",
  "title": "_title_56btq_145",
  "rightContent": "_rightContent_56btq_153",
  "profileNavigation": "_profileNavigation_56btq_160",
  "contextualMenu": "_contextualMenu_56btq_168",
  "contentProjectRedirection": "_contentProjectRedirection_56btq_176",
  "contentModal": "_contentModal_56btq_180",
  "constraints": "_constraints_56btq_187",
  "constraintsText": "_constraintsText_56btq_195",
  "list": "_list_56btq_201",
  "folderIcon": "_folderIcon_56btq_208",
  "icon": "_icon_56btq_212",
  "scenePlaceholder": "_scenePlaceholder_56btq_218"
};